import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import CheckBoxMC from '../../../../../components/CheckBoxMC';
import DropdownMC from '../../../../../components/DropdownMC';

const OrderPriceActionsSelector = ({
  selectedAllProducts,
  selectAllProducts,
  handlePriceChange
}) => {
  const { t: tCommon } = useTranslation('Common');
  const { t } = useTranslation('Orders');

  const priceOptions = useMemo(() => [
    { id: 'wholesalePrice', value: 'wholesalePrice', label: t('priceActions.switchToWholesalePrice') },
    { id: 'retailPrice', value: 'retailPrice', label: t('priceActions.switchToRegularPrice') }
  ], [t]);

  return (
    <div className="tw-wrapper">
      <div className="tw-flex tw-justify-between tw-items-center tw-border-b tw-pb-1">
        <div className="tw-flex tw-items-center tw-gap-2 tw-pl-4">
          <CheckBoxMC
            checked={selectedAllProducts}
            onChange={selectAllProducts}
            className="tw-w-3 tw-h-3"
          />
          <span className="tw-text-sm tw-text-gray-700 tw-py-4 tw-px-6">{t('priceActions.selected')}</span>
        </div>

        <div className="tw-flex tw-w-[240px]">
          <DropdownMC
            useFloatingLabel
            id="priceActionSelector"
            name="priceActionSelector"
            label={tCommon('actions.title')}
            options={priceOptions}
            onSelect={handlePriceChange}
          />
        </div>
      </div>
    </div>
  );
};

export default memo(OrderPriceActionsSelector);
